import App from './src/javascript/app';
import './src/styles/styles.css';

new App();